import { createSelector } from 'reselect';

const OrganizerList = {
    createOrganizerPosterListSelector: () => createSelector([
        (state) => state.organizerPosterList.getList.data,
    ], (data) => {
        if (data.results) {
            const formattedCompanies = [];
            for (let i = 0; i < data.results.length; i += 1) {
                const company = data.results[i];
                formattedCompanies.push({
                    id: company.id,
                    name: company.full_name,
                    description: company.description,
                    image: company.image,
                    companyType: company.company_type,
                });
            }
            const formattedData = {
                page: data.page,
                size: data.page_size,
                totalItems: data.total_length,
                totalPages: data.total_page,
                results: formattedCompanies,
            };
            return formattedData;
        }
        return { results: [] };
    }),
};

export default OrganizerList;
